export function getCookie() {
  return document.cookie;
}
export function getUrl() {
  return window.location.href;
}
export function getReferrer() {
  return document.referrer;
}